import Vue from 'vue';
import axios from 'axios';

export default {
  state: {
    user: '',
    employee: false,
    fullName: '',
    language: 'en',
    settings: {},
    wPlaceSettings: {},
    userInterfaceSettings: {
      showAllTransactions: true,
      activeWidget: 0,
    },
    employeeSettings: {
      area: 0,
      approval: false,
    },
    df: {
      date: 'DD.MM.YYYY',
      time: 'HH:mm',
      dateTime: 'DD.MM. HH:mm',
      dateYearTime: 'DD.MM.YYYY HH:mm',
      firstDayOfWeek: 0,
    },
    userSettings: {
      allowImport: false,
      language: 'en',
      accEmployees: {
        read: false,
        write: false,
        update: false,
        delete: false,
        import: false,
        export: false,
      },
      accEmployeeGroups: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accMessages: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accTemplates: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accCards: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accCars: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accWorkplaces: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accAreas: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accVisitors: {
        read: false,
        write: false,
        update: false,
        delete: false,
        import: false,
        export: false,
      },
      accCompanies: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accUsers: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accSettings: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accDocumentTypes: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accItems: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accMobileDevices: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accSignTerm: {
        read: false,
        write: false,
        update: false,
        delete: false,
      },
      accArchive: {
        // musi byt true aby usera nevykoplo z archivu pred tym nez sa zisti zda ma na archiv prava
        // Zmenu nastaveni sleduje watcher
        read: true,
        import: false,
        export: false,
      },
    },
  },
  mutations: {
    user(state: any, data: string) {
      state.user = data;
    },
    employee(state: any, data: boolean) {
      state.employee = data;
    },
    language(state: any, data: string) {
      state.language = data;
    },
    fullName(state: any, data: string) {
      state.fullName = data;
    },
    appMode(state: any, data: any) {
      state.appMode = data;
    },
    settings(state: any, data: object) {
      state.settings = data;
    },
    wPlaceSettings(state: any, data: object) {
      state.wPlaceSettings = data;
    },
    userInterfaceSettings(state: any, data: object) {
      state.userInterfaceSettings = data;
    },
    showAllTransactions(state: any, data: object) {
      state.userInterfaceSettings.showAllTransactions = data;
    },
    activeWidget(state: any, data: object) {
      state.userInterfaceSettings.activeWidget = data;
    },
    employeeSettings(state: any, data: object) {
      state.employeeSettings = data;
    },
    userSettings(state: any, data: object) {
      state.userSettings = data;
    },
    prepareDates(state: any, data: any) {
      state.df.date = data.date;
      state.df.time = data.time;
      state.df.dateTime = data.date.replace(/[-/]?YYYY[-./]?/, '') + ' ' + data.time;
      state.df.dateYearTime = data.date + ' ' + data.time;
      state.df.firstDayOfWeek = data.firstDay;
    },
  },
  getters: {},
  actions: {
    login(context: any, data: object) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/login', data)
          .then((response) => {
            if (response.data.auth === false) {
              reject('authFailed');
            }
            context.commit('employee', response.data.employee);
            if (!response.data.employee) {
              context.dispatch('getUserSettings').then(() => {
                resolve(true);
              });
            } else {
              context.dispatch('getEmployeeSettings');
              resolve(true);
            }
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
    logout(context: any) {
      // console.log('somvLogout', Vue.prototype.$socket);
      if (Vue.prototype.$socket) {
        //Vue.prototype.$socket.close(1000);
        Vue.prototype.$socket.$disconnect; // $disconnect();
        delete Vue.prototype.$socket;
      }
      return new Promise((resolve, reject) => {
        const action = 'logout';
        axios
          .post('/api/login', { action })
          .then(() => {
            // console.log('logout: ', response.data.message);
            context.commit('user', '');
            context.commit('employee', false);
            resolve(true);
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
    checkLogin(context: any) {
      // console.log('kontrolujem session');
      return new Promise((resolve, reject) => {
        context.commit('appMode', sessionStorage.appMode);
        axios
          .get('/api/login')
          .then((response) => {
            if (response.data.user === null) {
              reject('noSession');
            } else {
              context.commit('user', response.data.user);
              context.commit('employee', response.data.employee);
              // console.log('sessionOK');
              if (response.data.employee) {
                context.dispatch('getEmployeeSettings').then(() => {
                  context.dispatch('getSettings').then(() => {
                    context.state.settings.terms ? '' : reject('noTerms');
                    resolve('sessionOK');
                  });
                });
              } else {
                context.dispatch('getUserSettings').then(() => {
                  context.dispatch('getSettings').then(() => {
                    context.state.settings.terms ? '' : reject('noTerms');
                    resolve('sessionOK');
                  });
                });
              }
            }
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
    getSettings(context: any) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/settings')
          .then((response) => {
            context.commit('settings', response.data);
            resolve(true);
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(true);
          });
      });
    },
    getWorkplaceSettings(context: any) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/workplace/${localStorage.getItem('clientID')}`)
          .then((response) => {
            // Ak neexistuje vratnica z danym ID tak zhod nastavenia
            if (response.status === 204) {
              localStorage.removeItem('clientID');
              context.commit('clientID', '');
            }
            // Ak pracoviste je pracovistem prostoru tak presmeruj login
            if (response.data.area > 0) {
              if (process.env.NODE_ENV === 'development') {
                window.location.href = `http://${window.location.hostname}:8085/#/?clientID=${localStorage.getItem('clientID')}`;
              } else {
                window.location.href = '/iwp/';
              }
            }

            context.commit('wPlaceSettings', response.data);
            resolve(true);
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject();
          });
      });
    },
    getEmployeeSettings(context: any) {
      axios
        .get('/api/v1/employeesettings')
        .then((response) => {
          context.commit('fullName', response.data.fullName);
          context.commit('language', response.data.language);
          context.commit('employeeSettings', response.data);
          context.commit('prepareDates', {
            date: response.data.formatDate,
            time: response.data.formatTime,
            firstDay: response.data.firstDay,
          });
        })
        .catch((err) => {
          context.dispatch('catchErrHandler', err);
        });
    },
    getUserSettings(context: any) {
      return new Promise((resolve) => {
        // vezmi nastavenia interface
        if (context.state.user !== '') {
          axios.get('/api/v1/user/settings').then((response) => {
            // Ak je novy uzivatel preddefinuje sa default value
            if (response.data === '') {
              context.commit('userInterfaceSettings', { showAllTransactions: true });
            } else {
              context.commit('userInterfaceSettings', response.data);
            }
          });
        }
        const userSettings: any = JSON.parse(JSON.stringify(context.state.userSettings));

        // vezmi nastavenia opravneni
        axios
          .get('/api/v1/loginsettings')
          .then((response) => {
            context.commit('fullName', response.data.fullName);
            context.commit('language', response.data.language);
            const FlagRead = 1;
            const FlagWrite = 2;
            const FlagUpdate = 4;
            const FlagDelete = 8;
            const FlagImport = 16;
            const FlagExport = 32;
            const FlagPlanningUpdate = 16384;
            userSettings.allowImport = response.data.allowImport;
            context.commit('prepareDates', {
              date: response.data.formatDate,
              time: response.data.formatTime,
              firstDay: response.data.firstDay,
            });
            // Prepare Employees access settings
            userSettings.accEmployees.read = Boolean(response.data.accEmployees & FlagRead);
            userSettings.accEmployees.write = Boolean(response.data.accEmployees & FlagWrite);
            userSettings.accEmployees.update = Boolean(response.data.accEmployees & FlagUpdate);
            userSettings.accEmployees.delete = Boolean(response.data.accEmployees & FlagDelete);
            userSettings.accEmployees.import = Boolean(response.data.accEmployees & FlagImport);
            userSettings.accEmployees.export = Boolean(response.data.accEmployees & FlagExport);
            userSettings.accEmployees.planningUpdate = Boolean(response.data.accEmployees & FlagPlanningUpdate);
            // Prepare emloyeeGroups access settings
            userSettings.accEmployeeGroups.read = Boolean(response.data.accEmployeeGroups & FlagRead);
            userSettings.accEmployeeGroups.write = Boolean(response.data.accEmployeeGroups & FlagWrite);
            userSettings.accEmployeeGroups.update = Boolean(response.data.accEmployeeGroups & FlagUpdate);
            userSettings.accEmployeeGroups.delete = Boolean(response.data.accEmployeeGroups & FlagDelete);
            // Prepare messages access settings
            userSettings.accMessages.read = Boolean(response.data.accMessages & FlagRead);
            userSettings.accMessages.write = Boolean(response.data.accMessages & FlagWrite);
            userSettings.accMessages.update = Boolean(response.data.accMessages & FlagUpdate);
            userSettings.accMessages.delete = Boolean(response.data.accMessages & FlagDelete);
            // Prepare templates access settings
            userSettings.accTemplates.read = Boolean(response.data.accTemplates & FlagRead);
            userSettings.accTemplates.write = Boolean(response.data.accTemplates & FlagWrite);
            userSettings.accTemplates.update = Boolean(response.data.accTemplates & FlagUpdate);
            userSettings.accTemplates.delete = Boolean(response.data.accTemplates & FlagDelete);
            // Prepare Cards access settings
            userSettings.accCards.read = Boolean(response.data.accCards & FlagRead);
            userSettings.accCards.write = Boolean(response.data.accCards & FlagWrite);
            userSettings.accCards.update = Boolean(response.data.accCards & FlagUpdate);
            userSettings.accCards.delete = Boolean(response.data.accCards & FlagDelete);
            userSettings.accCards.import = Boolean(response.data.accCards & FlagImport);
            userSettings.accCards.export = Boolean(response.data.accCards & FlagExport);
            // Prepare Cars access settings
            userSettings.accCars.read = Boolean(response.data.accCars & FlagRead);
            userSettings.accCars.write = Boolean(response.data.accCars & FlagWrite);
            userSettings.accCars.update = Boolean(response.data.accCars & FlagUpdate);
            userSettings.accCars.delete = Boolean(response.data.accCars & FlagDelete);
            // Prepare Workplaces access settings
            userSettings.accWorkplaces.read = Boolean(response.data.accWorkplaces & FlagRead);
            userSettings.accWorkplaces.write = Boolean(response.data.accWorkplaces & FlagWrite);
            userSettings.accWorkplaces.update = Boolean(response.data.accWorkplaces & FlagUpdate);
            userSettings.accWorkplaces.delete = Boolean(response.data.accWorkplaces & FlagDelete);
            // Prepare Areas access settings
            userSettings.accAreas.read = Boolean(response.data.accAreas & FlagRead);
            userSettings.accAreas.write = Boolean(response.data.accAreas & FlagWrite);
            userSettings.accAreas.update = Boolean(response.data.accAreas & FlagUpdate);
            userSettings.accAreas.delete = Boolean(response.data.accAreas & FlagDelete);
            // Prepare Visitors access settings
            userSettings.accVisitors.read = Boolean(response.data.accVisitors & FlagRead);
            userSettings.accVisitors.write = Boolean(response.data.accVisitors & FlagWrite);
            userSettings.accVisitors.update = Boolean(response.data.accVisitors & FlagUpdate);
            userSettings.accVisitors.delete = Boolean(response.data.accVisitors & FlagDelete);
            userSettings.accVisitors.import = Boolean(response.data.accVisitors & FlagImport);
            userSettings.accVisitors.export = Boolean(response.data.accVisitors & FlagExport);
            // Prepare Companies access settings
            userSettings.accCompanies.read = Boolean(response.data.accCompanies & FlagRead);
            userSettings.accCompanies.write = Boolean(response.data.accCompanies & FlagWrite);
            userSettings.accCompanies.update = Boolean(response.data.accCompanies & FlagUpdate);
            userSettings.accCompanies.delete = Boolean(response.data.accCompanies & FlagDelete);
            // Prepare Users access settings
            userSettings.accUsers.read = Boolean(response.data.accUsers & FlagRead);
            userSettings.accUsers.write = Boolean(response.data.accUsers & FlagWrite);
            userSettings.accUsers.update = Boolean(response.data.accUsers & FlagUpdate);
            userSettings.accUsers.delete = Boolean(response.data.accUsers & FlagDelete);
            // Prepare System access settings
            userSettings.accSettings.read = Boolean(response.data.accSettings & FlagRead);
            userSettings.accSettings.write = Boolean(response.data.accSettings & FlagWrite);
            userSettings.accSettings.update = Boolean(response.data.accSettings & FlagUpdate);
            userSettings.accSettings.delete = Boolean(response.data.accSettings & FlagDelete);
            // Prepare DocumentTypes access settings
            userSettings.accDocumentTypes.read = Boolean(response.data.accDocumentTypes & FlagRead);
            userSettings.accDocumentTypes.write = Boolean(response.data.accDocumentTypes & FlagWrite);
            userSettings.accDocumentTypes.update = Boolean(response.data.accDocumentTypes & FlagUpdate);
            userSettings.accDocumentTypes.delete = Boolean(response.data.accDocumentTypes & FlagDelete);
            // Prepare Items access settings
            userSettings.accItems.read = Boolean(response.data.accItems & FlagRead);
            userSettings.accItems.write = Boolean(response.data.accItems & FlagWrite);
            userSettings.accItems.update = Boolean(response.data.accItems & FlagUpdate);
            userSettings.accItems.delete = Boolean(response.data.accItems & FlagDelete);
            // Prepare MobileDevices access settings
            userSettings.accMobileDevices.read = Boolean(response.data.accMobileDevices & FlagRead);
            userSettings.accMobileDevices.write = Boolean(response.data.accMobileDevices & FlagWrite);
            userSettings.accMobileDevices.update = Boolean(response.data.accMobileDevices & FlagUpdate);
            userSettings.accMobileDevices.delete = Boolean(response.data.accMobileDevices & FlagDelete);
            // Prepare SignatureTerminal access settings
            userSettings.accSignTerm.read = Boolean(response.data.accSignTerm & FlagRead);
            userSettings.accSignTerm.write = Boolean(response.data.accSignTerm & FlagWrite);
            userSettings.accSignTerm.update = Boolean(response.data.accSignTerm & FlagUpdate);
            userSettings.accSignTerm.delete = Boolean(response.data.accSignTerm & FlagDelete);
            // Prepare Archive access settings
            userSettings.accArchive.read = Boolean(response.data.accArchive & FlagRead);
            userSettings.accArchive.import = Boolean(response.data.accArchive & FlagImport);
            userSettings.accArchive.export = Boolean(response.data.accArchive & FlagExport);

            // A zapiseme nastavenia do storu
            context.commit('userSettings', userSettings);
            resolve(true);
          })
          .catch((err) => {
            console.log('ERR_STN: ', err);
            context.dispatch('catchErrHandler', err);
            resolve(false);
          });
      });
    },
  },
};
